import { Col, Row, Label, Nav, NavItem, NavLink } from 'reactstrap'
import DatetimeRenderer from "../../../../../Material/DatetimeRenderer"
import { Link } from "react-router-dom"

export default function LegacyRentalDetail({ stage, startDate, endDate, agreementType, branch, vin, bosCarId }) {
    if (!stage || !startDate || !vin || !bosCarId) return <div></div>
    return (
        <Col className="zero-padding">
            <div className="agreement-detail">
                <Row>
                    <Col style={{ marginBottom: "15px" }}>
                        <Nav tabs>
                            <NavItem className="active">
                                <NavLink className="active navItem" onClick={() => this.toggleSectionNav("rentalDetailSubsection", "Rental Info")}>
                                    LEGACY RENTAL INFO
                                </NavLink>
                            </NavItem>
                        </Nav>
                        <div className="info-container" style={{ borderTopLeftRadius: "0px" }}>
                            <Row>
                                <Col xs={3}>
                                    <Label>Stage</Label>
                                    <p>{stage}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Start Date</Label>
                                    <p>{startDate ? <DatetimeRenderer datetime={startDate} /> : "--"}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>End Date</Label>
                                    <p>{endDate ? <DatetimeRenderer datetime={endDate} /> : "--"}
                                    </p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Return Reason</Label>
                                    <p>{agreementType}</p>
                                </Col>
                            </Row>
                            <br />
                            <Row>
                                <Col xs={3}>
                                    <Label>Car ID</Label>
                                    <p>{bosCarId} &nbsp;
                                        <Link to={`/car/${bosCarId}`}>
                                            <i className="fa fa-external-link color-blue" />
                                        </Link>
                                    </p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Vin</Label>
                                    <p>{vin}</p>
                                </Col>
                                <Col xs={3}>
                                    <Label>Agreement Type</Label>
                                    <p>{agreementType}</p>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        </Col>
    )
}